module.exports = __webpack_public_path__ + "img/chinesecompany18.7a75c415.png";